import React from "react";
import { View, Modal, StyleSheet, TouchableOpacity } from "react-native";
import CloseIcon from "@assets/svg/CloseIcon";
import RadioButton from "@components/RadioButton";
import { useSelector } from "react-redux";

import analytics from "@services/analytics";

import Text from "@components/AppText";
import colors from "@constants/color";
import metrics from "@constants/metrics";
import {
  CONFIRM_ORDER_CANCEL,
  HIDE_ORDER_CANCEL_REASON_MODAL,
} from "../constants/analyticsEvents";
import { ORDER_FLOW_EVENTS } from "../constants/analyticsEventsCT";

import t from "../constants/localization";

const PATH = "components/OrderCancelReasonsModal";

const OrderCancelReasonsModal = (props) => {
  const {
    shouldShowModal = false,
    handleModalClose = () => {},
    reasons = [],
    setSelectedReason = () => {},
    selectedReasonIndex = null,
    onCancelOrder = () => {},
    fromScreen = "",
  } = props || {};

  const { allOrders = [], selectedOrder = "" } = useSelector(
    ({ orders }) => orders,
  );
  const {
    id: leader_id = "",
    name: leader_name = "",
    phone_number: leader_phone = "",
  } = useSelector(({ auth: { user } }) => user);
  const selectedOrderDetails =
    Array.isArray(allOrders) &&
    allOrders.length &&
    allOrders.find(({ order_id }) => +order_id === selectedOrder);

  const {
    order_id = "",
    total_amount: order_amount = "",
    items = [],
    collectible_amount: cod_amount = "",
    coupon_code = "",
    order_status = "",
    created_at: order_date = "",
  } = selectedOrderDetails || {};

  const closeModalWithAnalytics = () => {
    handleModalClose(false);
    // analytics.trackEvent(HIDE_ORDER_CANCEL_REASON_MODAL, {
    //   order_id,
    //   cancellation_reason: selectedReasonIndex,
    //   leader_id,
    //   leader_name,
    //   leader_phone,
    //   order_amount,
    //   num_of_items: items && items.length,
    //   items,
    //   discount: order_amount - cod_amount,
    //   coupon_code,
    //   cod_amount,
    //   order_status,
    //   order_date,
    //   screen: fromScreen,
    // });
  };

  const cancelOrderWithAnlaytics = () => {
    // analytics.trackEvent(ORDER_FLOW_EVENTS.ORDER_CANCELLED, {
    //   order_id,
    //   cancellation_reason: selectedReasonIndex,
    //   leader_id,
    //   leader_name,
    //   leader_phone,
    //   order_amount,
    //   num_of_items: items && items.length,
    //   items,
    //   discount: order_amount - cod_amount,
    //   coupon_code,
    //   cod_amount,
    //   order_status,
    //   order_date,
    // });
    onCancelOrder();
  };

  return (
    <Modal
      statusBarTranslucent
      navigationBarTranslucent
      animationType="fade"
      transparent
      visible={shouldShowModal}
      onRequestClose={() => closeModalWithAnalytics()}
    >
      <View style={styles.container}>
        <View style={styles.wrapper}>
          <View
            style={[
              styles.beLikeRow,
              { justifyContent: "space-between", alignItems: "center" },
            ]}
          >
            <View style={{ width: "80%" }}>
              <Text
                fontType="head2"
                style={{ color: colors.mediumBlack, fontWeight: "bold" }}
              >
                {t(`${PATH}/selectReason`)}
              </Text>
            </View>
            <TouchableOpacity onPress={() => closeModalWithAnalytics()}>
              <CloseIcon />
            </TouchableOpacity>
          </View>

          <View style={styles.radioBtnContainer}>
            <RadioButton
              radioOptions={reasons}
              setSelectedOption={setSelectedReason}
            />
          </View>

          <TouchableOpacity
            disabled={selectedReasonIndex === null}
            style={[
              styles.buttonsContainer,
              {
                backgroundColor:
                  selectedReasonIndex !== null ? colors.primary : colors.silver,
              },
            ]}
            onPress={() => cancelOrderWithAnlaytics()}
          >
            <Text
              fontType="head2"
              style={{
                color: colors.white,
                lineHeight: 28,
                fontWeight: "bold",
              }}
            >
              {t(`${PATH}/cancelOrder`)}
            </Text>
          </TouchableOpacity>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: colors.modalBg,
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    padding: 30,
  },
  beLikeRow: {
    flexDirection: "row",
  },
  wrapper: {
    backgroundColor: colors.white,
    elevation: 5,
    width: metrics.screenWidth * 0.9,
    padding: 20,
  },
  buttonsContainer: {
    width: "100%",
    height: 48,
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    alignSelf: "center",
    borderRadius: 10,
    backgroundColor: colors.silver,
  },
  radioBtnContainer: {
    paddingHorizontal: 5,
    marginVertical: 10,
    width: metrics.screenWidth,
  },
});

export default OrderCancelReasonsModal;
